import React, {
  useCallback, useMemo,
} from 'react';

import { useSelector, useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import useLocale from '@/hooks/useLocale';

import VpsStoreModal from '@/pages/Products/VpsOciDetailPage/ProductTemplatesPage/commons/VpsStoreModal';

import { vpsOciActions } from '@/redux/modules/productDetail/vpsOci';

const ModalRebuild = ({
  onClose,
}) => {
  const dispatch = useDispatch();

  const vpsOci = useSelector(state => state.vpsOci);
  const { vps } = (vpsOci && vpsOci.data) || {};

  const { productDetails: productDetailsLocale } = useLocale();
  const { vpsOci: localeVpsOci } = productDetailsLocale;
  const { modal: localeRebuildModal } = localeVpsOci && localeVpsOci.store && localeVpsOci.store.rebuild;
  const { alert: localeVpsOciStoreModalAlert } = localeVpsOci && localeVpsOci.store && localeVpsOci.store.modal;

  const { id: hostingId } = useParams();

  const handleCloseModal = useCallback(() => {
    onClose && onClose();
  }, [onClose]);

  const handleRebuild = useCallback(() => {
    if (hostingId) {
      dispatch(vpsOciActions.rebuild.request(hostingId));
    }
  }, [dispatch, hostingId]);

  const modalConfig = useMemo(() => ({
    confirmRebuild: {
      title: localeRebuildModal.confirmRebuild.title,
      message: localeRebuildModal.confirmRebuild.message,
      alert: localeVpsOciStoreModalAlert.backup,
      testId: 'vpsoci-rebuild-confirm-modal',
      confirmButton: {
        text: localeRebuildModal.confirmRebuild.confirmButton,
        action: handleRebuild,
        testId: 'vpsoci-rebuild-confirm-modal-confirm-button',
      },
      agreedTerms: localeRebuildModal.confirmRebuild.agreedTerms,
      closeButton: {
        text: localeRebuildModal.confirmRebuild.closeButton,
        action: handleCloseModal,
        testId: 'vpsoci-rebuild-confirm-modal-close-button',
      },
    },
  }), [handleCloseModal, handleRebuild, localeRebuildModal, localeVpsOciStoreModalAlert]);

  if (!vps || Object.keys(vps).length === 0) return null;

  return (
    <VpsStoreModal
      modalType="confirmRebuild"
      modalConfig={modalConfig}
      onClose={handleCloseModal}
    />
  );
};

export default ModalRebuild;
